// extracted by mini-css-extract-plugin
export default {"mainRecipt":"Recipt_mainRecipt__r4LkB","hotelrecipt":"Recipt_hotelrecipt__DXOYb","flightrecipt":"Recipt_flightrecipt__5+t5U"};